import React, { useState } from "react";

interface QuizEntryProps {
    onJoin: (username: string) => void;
}

export default function QuizEntry({ onJoin }: QuizEntryProps) {
    const [username, setUsername] = useState("");

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (username.trim()) {
            if (username.trim()) {
                onJoin(username.trim());
            }
        }
    };

    return (
        <div className="max-w-md mx-auto bg-white rounded-xl shadow-lg overflow-hidden md:max-w-2xl p-8 text-center mt-10">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">TUS Düellosuna Katıl! 🎮</h2>
            <p className="text-gray-600 mb-8">
                Bir yarışmaya davet edildiniz. Başlamak için isminizi girin!
            </p>

            <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="İsminiz (örn. Ahmet)"
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                        required
                    />
                </div>

                <button
                    type="submit"
                    disabled={!username.trim()}
                    className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg transition duration-300 ease-in-out transform hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed shadow-md"
                >
                    Yarışmaya Katıl
                </button>
            </form>
        </div>
    );
}
